export default __webpack_public_path__ + "static/media/detail_mobile_9_5.910e8e90.jpg";